export default {
  items: [
    {
      name: 'Agencies',
      url: '/agencies',
      roles: ['AWESOME', 'SUPER_ADMIN', 'ADMIN'],
      icon: 'fa fa-user-plus'
    },
    {
      name: 'Sub Agencies',
      url: '/sub-agencies',
      roles: ['AWESOME','AGENCY'],
      icon: 'fa fa-user-plus',
    },
    {
      name: 'Agents',
      url: '/agents',
      roles: ['AWESOME'],
      icon: 'fa fa-users',
    },
    {
      name: 'Mailing Profiles',
      url: '/mailing-profiles',
      roles: ['AWESOME', 'ADMIN', 'SUPER_ADMIN', 'AGENCY'],
      icon: 'fa fa-send',
    },
    {
      name: 'Mailing List',
      url: '/mailing-list',
      roles: ['AWESOME', 'ADMIN', 'SUPER_ADMIN', 'AGENCY'],
      icon: 'icon-list',
    },
    {
      name: 'Jobs',
      url: '/projects',
      roles: ['SUPER_ADMIN','ADMIN'],
      icon: 'icon-energy',
    },
    {
      name: 'Product List',
      url: '/mail-pieces',
      roles: ['AWESOME', 'SUPER_ADMIN', 'ADMIN', 'AGENCY'],
      icon: 'icon-list',
    },
    {
      name: 'Orders History',
      url: '/mailing-orders',
      roles: ['AWESOME', 'SUPER_ADMIN','ADMIN'],
      icon: 'fa fa-history',
    },
    {
      name: 'Enrollment',
      url: '/enrollment',
      roles: ['SUPER_ADMIN'],
      icon: 'fa fa-send',
    },
    {
      name: 'Preview',
      url: '/preview',
      roles: ['AGENCY'],
      icon: 'fa fa-send',
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      roles: ['AWESOME'],
      badge: {
        variant: 'info',
        text: 'NEW',
      },
    },
    {
      title: true,
      name: 'Theme',
      roles: ['AWESOME'],
      wrapper: {            // optional wrapper object
        element: '',        // required valid HTML5 element tag
        attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: ''             // optional class names space delimited list for title item ex:
    },
    {
      name: 'Colors',
      url: '/theme/colors',
      roles: ['AWESOME'],
      icon: 'icon-drop',
    },
    {
      name: 'Typography',
      url: '/theme/typography',
      roles: ['AWESOME'],
      icon: 'icon-pencil',
    },
    {
      title: true,
      name: 'Components',
      roles: ['AWESOME'],
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Base',
      url: '/base',
      roles: ['AWESOME'],
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Breadcrumbs',
          url: '/base/breadcrumbs',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Cards',
          url: '/base/cards',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Carousels',
          url: '/base/carousels',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Collapses',
          url: '/base/collapses',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Dropdowns',
          url: '/base/dropdowns',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Forms',
          url: '/base/forms',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Jumbotrons',
          url: '/base/jumbotrons',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'List groups',
          url: '/base/list-groups',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Navs',
          url: '/base/navs',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Paginations',
          url: '/base/paginations',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Popovers',
          url: '/base/popovers',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Progress Bar',
          url: '/base/progress-bar',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Switches',
          url: '/base/switches',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Tables',
          url: '/base/tables',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Tabs',
          url: '/base/tabs',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
        {
          name: 'Tooltips',
          url: '/base/tooltips',
          roles: ['AWESOME'],
          icon: 'icon-puzzle',
        },
      ],
    },
    {
      name: 'Buttons',
      url: '/buttons',
      icon: 'icon-cursor',
      roles: ['AWESOME'],
      children: [
        {
          name: 'Buttons',
          url: '/buttons/buttons',
          roles: ['AWESOME'],
          icon: 'icon-cursor',
        },
        {
          name: 'Button dropdowns',
          url: '/buttons/button-dropdowns',
          roles: ['AWESOME'],
          icon: 'icon-cursor',
        },
        {
          name: 'Button groups',
          url: '/buttons/button-groups',
          roles: ['AWESOME'],
          icon: 'icon-cursor',
        },
        {
          name: 'Brand Buttons',
          url: '/buttons/brand-buttons',
          roles: ['AWESOME'],
          icon: 'icon-cursor',
        },
      ],
    },
    {
      name: 'Charts',
      url: '/charts',
      roles: ['AWESOME'],
      icon: 'icon-pie-chart',
    },
    {
      name: 'Icons',
      url: '/icons',
      roles: ['AWESOME'],
      icon: 'icon-star',
      children: [
        {
          name: 'CoreUI Icons',
          url: '/icons/coreui-icons',
          roles: ['AWESOME'],
          icon: 'icon-star',
          badge: {
            variant: 'info',
            text: 'NEW',
          },
        },
        {
          name: 'Flags',
          url: '/icons/flags',
          roles: ['AWESOME'],
          icon: 'icon-star',
        },
        {
          name: 'Font Awesome',
          url: '/icons/font-awesome',
          roles: ['AWESOME'],
          icon: 'icon-star',
          badge: {
            variant: 'secondary',
            text: '4.7',
          },
        },
        {
          name: 'Simple Line Icons',
          url: '/icons/simple-line-icons',
          roles: ['AWESOME'],
          icon: 'icon-star',
        },
      ],
    },
    {
      name: 'Notifications',
      url: '/notifications',
      roles: ['AWESOME'],
      icon: 'icon-bell',
      children: [
        {
          name: 'Alerts',
          url: '/notifications/alerts',
          roles: ['AWESOME'],
          icon: 'icon-bell',
        },
        {
          name: 'Badges',
          url: '/notifications/badges',
          roles: ['AWESOME'],
          icon: 'icon-bell',
        },
        {
          name: 'Modals',
          url: '/notifications/modals',
          roles: ['AWESOME'],
          icon: 'icon-bell',
        },
      ],
    },
    {
      name: 'Widgets',
      url: '/widgets',
      roles: ['AWESOME'],
      icon: 'icon-calculator',
      badge: {
        variant: 'info',
        text: 'NEW',
      },
    },
    {
      divider: true,
    },
    {
      title: true,
      name: 'Extras',
      roles: ['AWESOME'],
    },
    {
      name: 'Pages',
      url: '/pages',
      roles: ['AWESOME'],
      icon: 'icon-star',
      children: [
        {
          name: 'Login',
          url: '/login',
          roles: ['AWESOME'],
          icon: 'icon-star',
        },
        {
          name: 'Register',
          url: '/register-agent',
          roles: ['AWESOME'],
          icon: 'icon-star',
        },
        {
          name: 'Error 404',
          url: '/404',
          roles: ['AWESOME'],
          icon: 'icon-star',
        },
        {
          name: 'Error 500',
          url: '/500',
          roles: ['AWESOME'],
          icon: 'icon-star',
        },
      ],
    },
    {
      name: 'Download CoreUI',
      url: 'http://coreui.io/react/',
      roles: ['AWESOME'],
      icon: 'icon-cloud-download',
      class: 'mt-auto',
      variant: 'success',
    },
    {
      name: 'Try CoreUI PRO',
      url: 'http://coreui.io/pro/react/',
      roles: ['AWESOME'],
      icon: 'icon-layers',
      variant: 'danger',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/_nav.js